import FooterLayout from "../layouts/FooterLayout";

export default function Footer() {
  return (
    <FooterLayout />
  );
}
